// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3pr5F","footer":"ChangeClinic_footer__2Z0LS"};